export const cleanTgGroupId = (raw: string) => {
  const value = String(raw ?? '').trim()
  if (!value) return ''

  const isNegative = value.startsWith('-')
  const digits = value.replace(/[^\d]/g, '')
  return isNegative ? `-${digits}` : digits
}

export const isValidTgGroupId = (groupId: string) => {
  const cleaned = cleanTgGroupId(groupId)
  if (!cleaned) return false

  // ID групп/чатов Telegram обычно длинные числовые строки (часто `-100...` для супергрупп).
  // Проверку держим достаточно мягкой, чтобы не отбрасывать реальные ID.
  if (!/^-?\d+$/.test(cleaned)) return false
  const digitsLen = cleaned.replace('-', '').length
  return digitsLen >= 3 && digitsLen <= 20
}

export default function tgGroupIdValidator(groupId: string) {
  if (!groupId) return 'Поле должно быть заполнено'
  if (!isValidTgGroupId(groupId)) return 'Некорректный id группы Telegram'
}

